import React from "react";
import GcProjectDetailPage from "./pages/GcProjectDetailPage";
import "./styles/gcProjectDetail.scss";

export default function GcProjectDetail() {
  return (
    <div className="gcProjectDetail">
      <GcProjectDetailPage />
    </div>
  );
}
